import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function GrowthPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">经营增长看板</h1>
        <p className="mt-1 text-sm text-muted-foreground">内容、线索、咨询、报名、成交和成本</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>北极星指标</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">功能和图表即将实现。</p>
        </CardContent>
      </Card>
    </div>
  );
}